"use client";
import dynamic from "next/dynamic";
const HorizontalShortcutCarousel = dynamic(() => import("./horizontal-shortcut-carousel"), { ssr: false });
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";

const HorizontalShortcutLoader = ({
    children,
    shortcutItems,
    priorityImage,
    session,
    loc,
    isOverflow,
}: {
    children?: React.ReactNode;
    shortcutItems: any;
    priorityImage?: boolean;
    session?: any;
    loc: string;
    isOverflow?: boolean;
}) => {
    const { hasMouseMoved } = useMouseMovement();
    return (
        <>
            {hasMouseMoved ? (
                <>
                    {isOverflow ? (
                        <HorizontalShortcutCarousel
                            shortcutItems={shortcutItems}
                            priorityImage={priorityImage}
                            session={session}
                            loc={loc}
                        />
                    ) : (
                        children
                    )}
                </>
            ) : (
                <>
                    <section className="min-h-[300px]">
                        {shortcutItems.map((item: any, index: number) => {
                            <img key={index} alt="shortcut" />;
                            {
                                item.title;
                            }
                            {
                                item.desc;
                            }
                        })}
                    </section>
                </>
            )}
        </>
    );
};

export default HorizontalShortcutLoader;
